import { nw02p, isToday } from './helpers'
function checkLocale (locale) {
  try {
    const supportedLocales = Intl.DateTimeFormat.supportedLocalesOf([locale])
    return supportedLocales.length ? locale : 'en-US'
  } catch (e) {
    // locale in a weird format, return en-US
    return 'en-US'
  }
}
const formatDateLong = function (val, locale) {
  const inval = '--'
  const date = new Date(val)
  if (isNaN(date) || date.getFullYear() === 1970) return inval
  const actualLocale = checkLocale(locale)

  if (isToday(date)) {
    const today = new Intl.RelativeTimeFormat(actualLocale, { numeric: 'auto' })
      .format(0, 'day')
    const time = new Intl.DateTimeFormat(actualLocale, {
      hour: 'numeric',
      minute: 'numeric'
    }).format(date)
    return `${today}, ${time}`
  }

  return new Intl.DateTimeFormat(actualLocale, {
    weekday: 'short',
    month: 'short',
    day: 'numeric',
    year: 'numeric',
    hour: 'numeric',
    minute: 'numeric'
  }).format(date)
}
// if not set will return today date
const formatDateISO = function (val) {
  let dt = new Date(val)
  if (isNaN(dt) || dt.getFullYear() === 1970) dt = new Date()

  const y = dt.getFullYear()
  const m = dt.getMonth() + 1
  const d = dt.getDate()

  return `${y}-${nw02p(m)}-${nw02p(d)}`
}
const formatDateReduced = function (date, scope, locale = 'en-US', includeSeconds = true, ampm = false) {
  const baseDate = new Date(date)
  const options = {
    hour: '2-digit',
    minute: '2-digit',
    timeZone: 'UTC',
    hour12: ampm
  }
  if (includeSeconds) options.second = '2-digit'
  switch (scope) {
    case 'month':
      options.month = '2-digit'
      options.day = '2-digit'
      break
    case 'week':
      options.weekday = 'short'
      break
    case 'day':
    case 'hour':
      break // No need to add any options since returning only time
    default:
      options.year = 'numeric'
      options.month = '2-digit'
      options.day = '2-digit'
      break
  }
  const actualLocale = checkLocale(locale)
  return Intl.DateTimeFormat(actualLocale, options).format(baseDate)
}

export { formatDateLong, formatDateISO, formatDateReduced }
